import { API_V1 } from '../config'
import { apiFetch } from './api'

export interface Department {
  id: number
  name: string
  color: string
  created_at: string
  document_count: number
}

export interface DocumentType {
  id: number
  name: string
  icon: string
  color: string
  is_default: boolean
  created_at: string
  document_count: number
}

export interface OrgMember {
  id: number
  koblink_id: string
  display_name: string
  email: string | null
  role: string
  joined_at: string
}

/** List departments for an organization */
export async function getDepartments(orgKoblinkId: string): Promise<Department[]> {
  const response = await apiFetch(
    `${API_V1}/organizations/${encodeURIComponent(orgKoblinkId)}/departments/`,
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch departments: ${response.status}`)
  }
  return response.json()
}

/** List document types for an organization */
export async function getDocumentTypes(orgKoblinkId: string): Promise<DocumentType[]> {
  const response = await apiFetch(
    `${API_V1}/organizations/${encodeURIComponent(orgKoblinkId)}/document-types/`,
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch document types: ${response.status}`)
  }
  return response.json()
}

/** List members of an organization */
export async function getMembers(orgKoblinkId: string): Promise<OrgMember[]> {
  const response = await apiFetch(
    `${API_V1}/organizations/${encodeURIComponent(orgKoblinkId)}/members/`,
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch members: ${response.status}`)
  }
  const data = await response.json()
  // Backend may wrap in { members: [...] } or return array directly
  return Array.isArray(data) ? data : data.members ?? []
}
